import axiosApiInstance from '@/api/shared/axios-instance';
import { mapToPrediccionPartido } from '@/components/alineaciones/mappers/MapToPrediccionDePartido';
import PrediccionPartidoComponent from '@/components/alineaciones/prediccion-partido/PrediccionPartidoComponent';
import Seo from '@/components/shared/custom/seo-component';
import Custom404Client from '@/components/site/Custom404Client';
import { IsrRevalidateTime } from '@/constants/cache-state-constants';
import { Rutas } from '@/constants/rutas';
import URL_FACTORY from '@/helpers/url-helper';

const PrediccionPartidoPage = ({ initialData, fixtureId }) => {
    const predictionData = mapToPrediccionPartido(initialData);
    const home = predictionData?.fixture?.home;
    const away = predictionData?.fixture?.away;

    const seo = {
        title: `${home?.name} vs ${away?.name}: Predicción de partido`,
        description: `Estadísticas y comparativa de ${home?.name} vs ${away?.name}, predicción de la IA sobre el partido.`,
        url: `${process.env.NEXT_PUBLIC_URL_FRONT}${Rutas.PARTIDO}/${fixtureId}/prediccion-de-partido`,
    };

    if (!predictionData) {
        return <Custom404Client />;
    }

    return (
        <>
            <Seo {...seo} />
            <PrediccionPartidoComponent predictionData={predictionData} />
        </>
    );
};

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

export async function getStaticProps({ params }) {
    const { slug } = params;

    try {
        const url = URL_FACTORY.ObtenerPrediccionDePartido(slug);
        const response = await axiosApiInstance.get(url);
        const initialData = response.data;

        return {
            props: {
                fixtureId: slug,
                initialData: initialData,
            },
            revalidate: IsrRevalidateTime.PREDICCION_PARTIDO,
        };
    } catch (_error) {
        console.error('Error fetching data:', _error);
        return {
            notFound: true,
        };
    }
}

export default PrediccionPartidoPage;
